// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-dashboard {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
}

.admin-dashboard h2 {
    color: #333;
    margin-bottom: 20px;
    border-bottom: 2px solid #007bff;
    padding-bottom: 10px;
}

.admin-tabs {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
    border-bottom: 1px solid #ddd;
}

.admin-tabs button {
    padding: 10px 20px;
    border: none;
    background: #f8f9fa;
    color: #333;
    cursor: pointer;
    border-radius: 5px 5px 0 0;
    transition: background-color 0.3s;
}

.admin-tabs button:hover {
    background: #e9ecef;
}

.admin-tabs button.active {
    background: #007bff;
    color: white;
}

.admin-content {
    background: white;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

/* Overview Tab */
.overview-tab h3 {
    color: #333;
    margin-bottom: 20px;
}

.stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
}

.stat-card {
    background: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    border-left: 4px solid #007bff;
}

.stat-card h4 {
    margin: 0 0 10px 0;
    color: #666;
}

.stat-value {
    font-size: 2.5em;
    font-weight: bold;
    color: #007bff;
    margin: 10px 0;
}

.stat-detail {
    color: #666;
    font-size: 0.9em;
}

/* Feedback Tab */
.feedback-tab h3 {
    color: #333;
    margin-bottom: 20px;
}

.feedback-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.feedback-item {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 15px;
    background: white;
}

.feedback-item.new {
    border-left: 4px solid #28a745;
}

.feedback-item.in_progress {
    border-left: 4px solid #ffc107;
}

.feedback-item.resolved {
    border-left: 4px solid #17a2b8;
}

.feedback-item.closed {
    border-left: 4px solid #6c757d;
}

.feedback-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.feedback-header h4 {
    margin: 0;
    color: #333;
}

.feedback-meta {
    display: flex;
    gap: 10px;
}

.feedback-meta span {
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.8em;
    font-weight: bold;
    text-transform: uppercase;
}

.type.bug {
    background: #dc3545;
    color: white;
}

.type.feature {
    background: #28a745;
    color: white;
}

.priority.low {
    background: #6c757d;
    color: white;
}

.priority.medium {
    background: #ffc107;
    color: #333;
}

.priority.high {
    background: #dc3545;
    color: white;
}

.status.new {
    background: #28a745;
    color: white;
}

.status.in_progress {
    background: #ffc107;
    color: #333;
}

.status.resolved {
    background: #17a2b8;
    color: white;
}

.status.closed {
    background: #6c757d;
    color: white;
}

.feedback-description {
    color: #666;
    margin: 10px 0;
    line-height: 1.4;
}

.feedback-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
}

.feedback-actions select {
    padding: 5px 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: white;
}

.feedback-date {
    color: #666;
    font-size: 0.9em;
}

/* Users Tab */
.users-tab h3 {
    color: #333;
    margin-bottom: 20px;
}

.users-table {
    overflow-x: auto;
}

.users-table table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
}

.users-table th,
.users-table td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

.users-table th {
    background: #f8f9fa;
    font-weight: bold;
    color: #333;
}

.users-table tr:hover {
    background: #f8f9fa;
}

.users-table tr.inactive {
    opacity: 0.6;
    background: #f8f8f8;
}

.role.admin {
    background: #dc3545;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.8em;
    font-weight: bold;
}

.role.user {
    background: #007bff;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.8em;
    font-weight: bold;
}

.role.reviewer {
    background: #28a745;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.8em;
    font-weight: bold;
}

.role-select {
    padding: 4px 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: white;
    font-size: 0.9em;
    min-width: 100px;
}

.role-select.admin {
    border-color: #dc3545;
}

.role-select.reviewer {
    border-color: #28a745;
}

.role-select.user {
    border-color: #007bff;
}

.user-actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.user-actions button {
    padding: 4px 8px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.8em;
    white-space: nowrap;
}

.status.active {
    color: #28a745;
    font-weight: bold;
}

.status.inactive {
    color: #dc3545;
    font-weight: bold;
}

.activate-btn {
    background: #28a745;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.9em;
}

.activate-btn:hover {
    background: #218838;
}

.deactivate-btn {
    background: #dc3545;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.9em;
}

.deactivate-btn:hover {
    background: #c82333;
}

.reset-password-btn {
    background: #ffc107;
    color: #333;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.9em;
}

.reset-password-btn:hover {
    background: #e0a800;
}

.impersonate-btn {
    background: #6f42c1;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.9em;
}

.impersonate-btn:hover {
    background: #5a2d91;
}

.loading {
    text-align: center;
    padding: 40px;
    color: #666;
}

.error {
    color: #dc3545;
    background: #f8d7da;
    padding: 15px;
    border-radius: 5px;
    margin: 20px 0;
}

@media (max-width: 768px) {
    .admin-dashboard {
        padding: 10px;
    }
    
    .admin-tabs {
        flex-direction: column;
        gap: 5px;
    }
    
    .admin-tabs button {
        border-radius: 5px;
    }
    
    .stats-grid {
        grid-template-columns: 1fr;
    }
    
    .feedback-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }
    
    .feedback-meta {
        flex-wrap: wrap;
    }
    
    .users-table {
        font-size: 0.9em;
    }
    
    .users-table th,
    .users-table td {
        padding: 8px;
        min-width: 100px;
    }
}

/* Matching Rules Tab */
.matching-rules-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
    gap: 20px;
}

.header-content h3 {
    color: #333;
    margin-bottom: 10px;
}

.header-content p {
    color: #666;
    margin-bottom: 0;
}

.btn-create-rule {
    background: #28a745;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-weight: 500;
    white-space: nowrap;
    transition: background-color 0.3s;
}

.btn-create-rule:hover {
    background: #218838;
}

/* Create Rule Form */
.create-rule-form {
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 30px;
}

.form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #dee2e6;
}

.form-header h4 {
    margin: 0;
    color: #333;
}

.btn-close {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #6c757d;
    padding: 5px;
    line-height: 1;
}

.btn-close:hover {
    color: #333;
}

.form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 20px;
}

.form-group {
    display: flex;
    flex-direction: column;
}

.form-group.full-width {
    grid-column: span 2;
}

.form-group label {
    font-weight: 500;
    margin-bottom: 5px;
    color: #333;
}

.form-group input,
.form-group select {
    padding: 8px 12px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 14px;
}

.form-group input:focus,
.form-group select:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.form-group small {
    color: #6c757d;
    font-size: 12px;
    margin-top: 3px;
}

.form-actions {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
}

.btn-save {
    background: #007bff;
    color: white;
    border: none;
    padding: 8px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
}

.btn-save:hover {
    background: #0056b3;
}

.btn-cancel {
    background: #6c757d;
    color: white;
    border: none;
    padding: 8px 20px;
    border-radius: 4px;
    cursor: pointer;
}

.btn-cancel:hover {
    background: #545b62;
}

.rules-table-container {
    overflow-x: auto;
    background: white;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.rules-table {
    width: 100%;
    border-collapse: collapse;
    margin: 0;
}

.rules-table th {
    background: #f8f9fa;
    padding: 12px;
    text-align: left;
    font-weight: 600;
    color: #333;
    border-bottom: 2px solid #dee2e6;
    white-space: nowrap;
}

.rules-table td {
    padding: 12px;
    border-bottom: 1px solid #dee2e6;
    vertical-align: middle;
}

.rules-table tr:hover {
    background: #f8f9fa;
}

.rules-table tr.inactive {
    opacity: 0.6;
    background: #f8f8f8;
}

.field-badge {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 0.85em;
    font-weight: 500;
    color: white;
    text-transform: uppercase;
}

.field-badge.field-projectName {
    background: #007bff;
}

.field-badge.field-contractorName {
    background: #28a745;
}

.field-badge.field-subcontractorName {
    background: #ffc107;
    color: #333;
}

.pattern-cell code {
    background: #f8f9fa;
    padding: 2px 6px;
    border-radius: 3px;
    font-family: 'Courier New', monospace;
    font-size: 0.9em;
    color: #e83e8c;
}

.mapped-cell strong {
    color: #28a745;
}

.status-badge {
    display: inline-block;
    padding: 3px 8px;
    border-radius: 10px;
    font-size: 0.85em;
    font-weight: 500;
    text-transform: uppercase;
}

.status-badge.active {
    background: #d4edda;
    color: #155724;
}

.status-badge.inactive {
    background: #f8d7da;
    color: #721c24;
}

.actions-cell {
    white-space: nowrap;
}

.actions-cell button {
    margin: 0 2px;
    padding: 5px 10px;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    font-size: 0.85em;
    transition: background-color 0.3s;
}

.btn-toggle.btn-enable {
    background: #28a745;
    color: white;
}

.btn-toggle.btn-enable:hover {
    background: #218838;
}

.btn-toggle.btn-disable {
    background: #ffc107;
    color: #333;
}

.btn-toggle.btn-disable:hover {
    background: #e0a800;
}

.btn-delete {
    background: #dc3545;
    color: white;
}

.btn-delete:hover {
    background: #c82333;
}

.no-data {
    text-align: center;
    padding: 40px;
    color: #666;
    background: #f8f9fa;
    border-radius: 5px;
    border: 2px dashed #dee2e6;
}

.no-data p {
    margin: 10px 0;
}

/* Responsive design for matching rules */
@media (max-width: 768px) {
    .matching-rules-header {
        flex-direction: column;
        align-items: stretch;
    }
    
    .btn-create-rule {
        align-self: flex-start;
    }
    
    .form-grid {
        grid-template-columns: 1fr;
        gap: 15px;
    }
    
    .form-group.full-width {
        grid-column: span 1;
    }
    
    .form-actions {
        flex-direction: column;
        align-items: stretch;
    }
    
    .rules-table-container {
        font-size: 0.85em;
    }
    
    .rules-table th,
    .rules-table td {
        padding: 8px 6px;
        font-size: 0.9em;
    }
    
    .pattern-cell,
    .mapped-cell {
        max-width: 150px;
        word-break: break-word;
    }
    
    .actions-cell button {
        padding: 3px 6px;
        font-size: 0.8em;
    }
}

/* Feedback Attachment Styles */
.feedback-attachment {
    margin: 15px 0;
    padding: 10px;
    background: #f8f9fa;
    border-radius: 6px;
    border: 1px solid #e0e0e0;
}

.feedback-attachment label {
    display: block;
    font-weight: 500;
    color: #555;
    margin-bottom: 8px;
    font-size: 0.9em;
}

.attachment-preview {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
}

.feedback-screenshot {
    max-width: 300px;
    max-height: 200px;
    width: auto;
    height: auto;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    border: 1px solid #ddd;
}

.feedback-screenshot:hover {
    transform: scale(1.02);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.attachment-actions {
    display: flex;
    gap: 8px;
    align-items: center;
}

.btn-preview,
.btn-download {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.85em;
    font-weight: 500;
    transition: background-color 0.3s, transform 0.1s;
    text-decoration: none;
}

.btn-preview {
    background: #007bff;
    color: white;
}

.btn-preview:hover {
    background: #0056b3;
    transform: translateY(-1px);
}

.btn-download {
    background: #28a745;
    color: white;
}

.btn-download:hover {
    background: #218838;
    transform: translateY(-1px);
}

.btn-preview:active,
.btn-download:active {
    transform: translateY(0);
}

.loading-image {
    padding: 20px;
    background: #f8f9fa;
    border: 2px dashed #ddd;
    border-radius: 4px;
    text-align: center;
    color: #666;
    font-style: italic;
}

@media (max-width: 768px) {
    .feedback-screenshot {
        max-width: 100%;
        max-height: 150px;
    }
    
    .attachment-preview {
        align-items: center;
    }
    
    .attachment-actions {
        flex-direction: column;
        width: 100%;
        gap: 6px;
    }
    
    .btn-preview,
    .btn-download {
        width: 100%;
        justify-content: center;
        padding: 8px 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/AdminDashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,0BAA0B;IAC1B,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA,cAAc;AACd;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,YAAY;QACZ,gBAAgB;IACpB;AACJ;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;IACd,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA,yCAAyC;AACzC;IACI;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;QAChB,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;AAEA,+BAA+B;AAC/B;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,eAAe;IACf,qDAAqD;IACrD,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iDAAiD;IACjD,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,QAAQ;IACZ;;IAEA;;QAEI,WAAW;QACX,uBAAuB;QACvB,iBAAiB;IACrB;AACJ","sourcesContent":[".admin-dashboard {\n    padding: 20px;\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n.admin-dashboard h2 {\n    color: #333;\n    margin-bottom: 20px;\n    border-bottom: 2px solid #007bff;\n    padding-bottom: 10px;\n}\n\n.admin-tabs {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 20px;\n    border-bottom: 1px solid #ddd;\n}\n\n.admin-tabs button {\n    padding: 10px 20px;\n    border: none;\n    background: #f8f9fa;\n    color: #333;\n    cursor: pointer;\n    border-radius: 5px 5px 0 0;\n    transition: background-color 0.3s;\n}\n\n.admin-tabs button:hover {\n    background: #e9ecef;\n}\n\n.admin-tabs button.active {\n    background: #007bff;\n    color: white;\n}\n\n.admin-content {\n    background: white;\n    padding: 20px;\n    border-radius: 5px;\n    box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n}\n\n/* Overview Tab */\n.overview-tab h3 {\n    color: #333;\n    margin-bottom: 20px;\n}\n\n.stats-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 20px;\n}\n\n.stat-card {\n    background: #f8f9fa;\n    padding: 20px;\n    border-radius: 8px;\n    text-align: center;\n    border-left: 4px solid #007bff;\n}\n\n.stat-card h4 {\n    margin: 0 0 10px 0;\n    color: #666;\n}\n\n.stat-value {\n    font-size: 2.5em;\n    font-weight: bold;\n    color: #007bff;\n    margin: 10px 0;\n}\n\n.stat-detail {\n    color: #666;\n    font-size: 0.9em;\n}\n\n/* Feedback Tab */\n.feedback-tab h3 {\n    color: #333;\n    margin-bottom: 20px;\n}\n\n.feedback-list {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n}\n\n.feedback-item {\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    padding: 15px;\n    background: white;\n}\n\n.feedback-item.new {\n    border-left: 4px solid #28a745;\n}\n\n.feedback-item.in_progress {\n    border-left: 4px solid #ffc107;\n}\n\n.feedback-item.resolved {\n    border-left: 4px solid #17a2b8;\n}\n\n.feedback-item.closed {\n    border-left: 4px solid #6c757d;\n}\n\n.feedback-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.feedback-header h4 {\n    margin: 0;\n    color: #333;\n}\n\n.feedback-meta {\n    display: flex;\n    gap: 10px;\n}\n\n.feedback-meta span {\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 0.8em;\n    font-weight: bold;\n    text-transform: uppercase;\n}\n\n.type.bug {\n    background: #dc3545;\n    color: white;\n}\n\n.type.feature {\n    background: #28a745;\n    color: white;\n}\n\n.priority.low {\n    background: #6c757d;\n    color: white;\n}\n\n.priority.medium {\n    background: #ffc107;\n    color: #333;\n}\n\n.priority.high {\n    background: #dc3545;\n    color: white;\n}\n\n.status.new {\n    background: #28a745;\n    color: white;\n}\n\n.status.in_progress {\n    background: #ffc107;\n    color: #333;\n}\n\n.status.resolved {\n    background: #17a2b8;\n    color: white;\n}\n\n.status.closed {\n    background: #6c757d;\n    color: white;\n}\n\n.feedback-description {\n    color: #666;\n    margin: 10px 0;\n    line-height: 1.4;\n}\n\n.feedback-actions {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 10px;\n}\n\n.feedback-actions select {\n    padding: 5px 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    background: white;\n}\n\n.feedback-date {\n    color: #666;\n    font-size: 0.9em;\n}\n\n/* Users Tab */\n.users-tab h3 {\n    color: #333;\n    margin-bottom: 20px;\n}\n\n.users-table {\n    overflow-x: auto;\n}\n\n.users-table table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 10px;\n}\n\n.users-table th,\n.users-table td {\n    padding: 12px;\n    text-align: left;\n    border-bottom: 1px solid #ddd;\n}\n\n.users-table th {\n    background: #f8f9fa;\n    font-weight: bold;\n    color: #333;\n}\n\n.users-table tr:hover {\n    background: #f8f9fa;\n}\n\n.users-table tr.inactive {\n    opacity: 0.6;\n    background: #f8f8f8;\n}\n\n.role.admin {\n    background: #dc3545;\n    color: white;\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 0.8em;\n    font-weight: bold;\n}\n\n.role.user {\n    background: #007bff;\n    color: white;\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 0.8em;\n    font-weight: bold;\n}\n\n.role.reviewer {\n    background: #28a745;\n    color: white;\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 0.8em;\n    font-weight: bold;\n}\n\n.role-select {\n    padding: 4px 8px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    background: white;\n    font-size: 0.9em;\n    min-width: 100px;\n}\n\n.role-select.admin {\n    border-color: #dc3545;\n}\n\n.role-select.reviewer {\n    border-color: #28a745;\n}\n\n.role-select.user {\n    border-color: #007bff;\n}\n\n.user-actions {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.user-actions button {\n    padding: 4px 8px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 0.8em;\n    white-space: nowrap;\n}\n\n.status.active {\n    color: #28a745;\n    font-weight: bold;\n}\n\n.status.inactive {\n    color: #dc3545;\n    font-weight: bold;\n}\n\n.activate-btn {\n    background: #28a745;\n    color: white;\n    border: none;\n    padding: 6px 12px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 0.9em;\n}\n\n.activate-btn:hover {\n    background: #218838;\n}\n\n.deactivate-btn {\n    background: #dc3545;\n    color: white;\n    border: none;\n    padding: 6px 12px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 0.9em;\n}\n\n.deactivate-btn:hover {\n    background: #c82333;\n}\n\n.reset-password-btn {\n    background: #ffc107;\n    color: #333;\n    border: none;\n    padding: 6px 12px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 0.9em;\n}\n\n.reset-password-btn:hover {\n    background: #e0a800;\n}\n\n.impersonate-btn {\n    background: #6f42c1;\n    color: white;\n    border: none;\n    padding: 6px 12px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 0.9em;\n}\n\n.impersonate-btn:hover {\n    background: #5a2d91;\n}\n\n.loading {\n    text-align: center;\n    padding: 40px;\n    color: #666;\n}\n\n.error {\n    color: #dc3545;\n    background: #f8d7da;\n    padding: 15px;\n    border-radius: 5px;\n    margin: 20px 0;\n}\n\n@media (max-width: 768px) {\n    .admin-dashboard {\n        padding: 10px;\n    }\n    \n    .admin-tabs {\n        flex-direction: column;\n        gap: 5px;\n    }\n    \n    .admin-tabs button {\n        border-radius: 5px;\n    }\n    \n    .stats-grid {\n        grid-template-columns: 1fr;\n    }\n    \n    .feedback-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n    }\n    \n    .feedback-meta {\n        flex-wrap: wrap;\n    }\n    \n    .users-table {\n        font-size: 0.9em;\n    }\n    \n    .users-table th,\n    .users-table td {\n        padding: 8px;\n        min-width: 100px;\n    }\n}\n\n/* Matching Rules Tab */\n.matching-rules-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 20px;\n    gap: 20px;\n}\n\n.header-content h3 {\n    color: #333;\n    margin-bottom: 10px;\n}\n\n.header-content p {\n    color: #666;\n    margin-bottom: 0;\n}\n\n.btn-create-rule {\n    background: #28a745;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-weight: 500;\n    white-space: nowrap;\n    transition: background-color 0.3s;\n}\n\n.btn-create-rule:hover {\n    background: #218838;\n}\n\n/* Create Rule Form */\n.create-rule-form {\n    background: #f8f9fa;\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    padding: 20px;\n    margin-bottom: 30px;\n}\n\n.form-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #dee2e6;\n}\n\n.form-header h4 {\n    margin: 0;\n    color: #333;\n}\n\n.btn-close {\n    background: none;\n    border: none;\n    font-size: 20px;\n    cursor: pointer;\n    color: #6c757d;\n    padding: 5px;\n    line-height: 1;\n}\n\n.btn-close:hover {\n    color: #333;\n}\n\n.form-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n    margin-bottom: 20px;\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column;\n}\n\n.form-group.full-width {\n    grid-column: span 2;\n}\n\n.form-group label {\n    font-weight: 500;\n    margin-bottom: 5px;\n    color: #333;\n}\n\n.form-group input,\n.form-group select {\n    padding: 8px 12px;\n    border: 1px solid #ced4da;\n    border-radius: 4px;\n    font-size: 14px;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n    outline: none;\n    border-color: #007bff;\n    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.form-group small {\n    color: #6c757d;\n    font-size: 12px;\n    margin-top: 3px;\n}\n\n.form-actions {\n    display: flex;\n    gap: 10px;\n    justify-content: flex-end;\n}\n\n.btn-save {\n    background: #007bff;\n    color: white;\n    border: none;\n    padding: 8px 20px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: 500;\n}\n\n.btn-save:hover {\n    background: #0056b3;\n}\n\n.btn-cancel {\n    background: #6c757d;\n    color: white;\n    border: none;\n    padding: 8px 20px;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.btn-cancel:hover {\n    background: #545b62;\n}\n\n.rules-table-container {\n    overflow-x: auto;\n    background: white;\n    border-radius: 5px;\n    box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n}\n\n.rules-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 0;\n}\n\n.rules-table th {\n    background: #f8f9fa;\n    padding: 12px;\n    text-align: left;\n    font-weight: 600;\n    color: #333;\n    border-bottom: 2px solid #dee2e6;\n    white-space: nowrap;\n}\n\n.rules-table td {\n    padding: 12px;\n    border-bottom: 1px solid #dee2e6;\n    vertical-align: middle;\n}\n\n.rules-table tr:hover {\n    background: #f8f9fa;\n}\n\n.rules-table tr.inactive {\n    opacity: 0.6;\n    background: #f8f8f8;\n}\n\n.field-badge {\n    display: inline-block;\n    padding: 4px 8px;\n    border-radius: 12px;\n    font-size: 0.85em;\n    font-weight: 500;\n    color: white;\n    text-transform: uppercase;\n}\n\n.field-badge.field-projectName {\n    background: #007bff;\n}\n\n.field-badge.field-contractorName {\n    background: #28a745;\n}\n\n.field-badge.field-subcontractorName {\n    background: #ffc107;\n    color: #333;\n}\n\n.pattern-cell code {\n    background: #f8f9fa;\n    padding: 2px 6px;\n    border-radius: 3px;\n    font-family: 'Courier New', monospace;\n    font-size: 0.9em;\n    color: #e83e8c;\n}\n\n.mapped-cell strong {\n    color: #28a745;\n}\n\n.status-badge {\n    display: inline-block;\n    padding: 3px 8px;\n    border-radius: 10px;\n    font-size: 0.85em;\n    font-weight: 500;\n    text-transform: uppercase;\n}\n\n.status-badge.active {\n    background: #d4edda;\n    color: #155724;\n}\n\n.status-badge.inactive {\n    background: #f8d7da;\n    color: #721c24;\n}\n\n.actions-cell {\n    white-space: nowrap;\n}\n\n.actions-cell button {\n    margin: 0 2px;\n    padding: 5px 10px;\n    border: none;\n    border-radius: 3px;\n    cursor: pointer;\n    font-size: 0.85em;\n    transition: background-color 0.3s;\n}\n\n.btn-toggle.btn-enable {\n    background: #28a745;\n    color: white;\n}\n\n.btn-toggle.btn-enable:hover {\n    background: #218838;\n}\n\n.btn-toggle.btn-disable {\n    background: #ffc107;\n    color: #333;\n}\n\n.btn-toggle.btn-disable:hover {\n    background: #e0a800;\n}\n\n.btn-delete {\n    background: #dc3545;\n    color: white;\n}\n\n.btn-delete:hover {\n    background: #c82333;\n}\n\n.no-data {\n    text-align: center;\n    padding: 40px;\n    color: #666;\n    background: #f8f9fa;\n    border-radius: 5px;\n    border: 2px dashed #dee2e6;\n}\n\n.no-data p {\n    margin: 10px 0;\n}\n\n/* Responsive design for matching rules */\n@media (max-width: 768px) {\n    .matching-rules-header {\n        flex-direction: column;\n        align-items: stretch;\n    }\n    \n    .btn-create-rule {\n        align-self: flex-start;\n    }\n    \n    .form-grid {\n        grid-template-columns: 1fr;\n        gap: 15px;\n    }\n    \n    .form-group.full-width {\n        grid-column: span 1;\n    }\n    \n    .form-actions {\n        flex-direction: column;\n        align-items: stretch;\n    }\n    \n    .rules-table-container {\n        font-size: 0.85em;\n    }\n    \n    .rules-table th,\n    .rules-table td {\n        padding: 8px 6px;\n        font-size: 0.9em;\n    }\n    \n    .pattern-cell,\n    .mapped-cell {\n        max-width: 150px;\n        word-break: break-word;\n    }\n    \n    .actions-cell button {\n        padding: 3px 6px;\n        font-size: 0.8em;\n    }\n}\n\n/* Feedback Attachment Styles */\n.feedback-attachment {\n    margin: 15px 0;\n    padding: 10px;\n    background: #f8f9fa;\n    border-radius: 6px;\n    border: 1px solid #e0e0e0;\n}\n\n.feedback-attachment label {\n    display: block;\n    font-weight: 500;\n    color: #555;\n    margin-bottom: 8px;\n    font-size: 0.9em;\n}\n\n.attachment-preview {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n}\n\n.feedback-screenshot {\n    max-width: 300px;\n    max-height: 200px;\n    width: auto;\n    height: auto;\n    border-radius: 4px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    cursor: pointer;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    border: 1px solid #ddd;\n}\n\n.feedback-screenshot:hover {\n    transform: scale(1.02);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.attachment-actions {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.btn-preview,\n.btn-download {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 6px 12px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 0.85em;\n    font-weight: 500;\n    transition: background-color 0.3s, transform 0.1s;\n    text-decoration: none;\n}\n\n.btn-preview {\n    background: #007bff;\n    color: white;\n}\n\n.btn-preview:hover {\n    background: #0056b3;\n    transform: translateY(-1px);\n}\n\n.btn-download {\n    background: #28a745;\n    color: white;\n}\n\n.btn-download:hover {\n    background: #218838;\n    transform: translateY(-1px);\n}\n\n.btn-preview:active,\n.btn-download:active {\n    transform: translateY(0);\n}\n\n.loading-image {\n    padding: 20px;\n    background: #f8f9fa;\n    border: 2px dashed #ddd;\n    border-radius: 4px;\n    text-align: center;\n    color: #666;\n    font-style: italic;\n}\n\n@media (max-width: 768px) {\n    .feedback-screenshot {\n        max-width: 100%;\n        max-height: 150px;\n    }\n    \n    .attachment-preview {\n        align-items: center;\n    }\n    \n    .attachment-actions {\n        flex-direction: column;\n        width: 100%;\n        gap: 6px;\n    }\n    \n    .btn-preview,\n    .btn-download {\n        width: 100%;\n        justify-content: center;\n        padding: 8px 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
